<template>

  <div class="menu_districts_slider mb-5" :class="widgetData.container">
    <div class="h4 mb-3" v-html="widgetData.description"></div>
    <div class="row d-flex flex-nowrap overflow-auto flex-lg-wrap my-0">
      <div class="col-9 col-md-4 col-lg-3 col-xxl-2 mb-3" v-for="menuItem in content">
        <nuxt-link :to="menuItem.getLinkWithSlash()" class="btn btn-outline-first rounded w-100">
          {{ menuItem.name }}
        </nuxt-link>
      </div>
    </div>
  </div>
</template>


<script setup lang="ts">
import {computed, PropType} from "vue";
import {PageDataHolderFetchedWidget} from "~/lib/interfaces/model/PageDataHolderFetchedWidget";
import {useWidget} from "../../../../composables/widget/menu";

const props = defineProps({
  widget: Object as PropType<PageDataHolderFetchedWidget>
});

const {content, widgetData} = useWidget(props.widget);
</script>
